import './partials/carousels.js'
import './partials/google_content.js'
import './partials/woocommerce.js'
import intlTelInput from 'intl-tel-input';

jQuery(document).ready(function($) {

  // single page sticky cart
  $('.storefront-sticky-add-to-cart__content-button').click(function(){
    if ($.trim($(this).text()) == 'Dodaj do koszyka') {
      $('.single_add_to_cart_button').click();
    } else {
      $('html, body').animate({
        scrollTop: $('.shipping-info').offset().top
      }, 1000);
    }
    return false;
  });

  // mobile search 
  $('.storefront-handheld-footer-bar .search').click(function(){
    $('#masthead .site-search').slideToggle();
  });

	// contact page
	$('input[type="checkbox"]').each(function() {
		let label = '';
		if($(this).closest('form').hasClass('comment-form')) {
			return false;
			label = $(this).next('label').text()
			$(this).next('label').text('');
			$(this).wrap('<div>');
		} 
		
			$(this).parent().addClass('pretty p-default p-smooth')
			$(this).after('<div class="state"><label>'+ label +'</label></div>')
	});

  const input = document.querySelector('input[type="tel"]');

  if (input) {
      intlTelInput(input, {
        initialCountry: "pl",
        separateDialCode: true,
      });
            
      input.addEventListener('blur', function() {
        if (input.value.trim()) {
            if (iti.isValidNumber()) {
                input.classList.remove("woocommerce-invalid");
                input.setCustomValidity('');
                input.setAttribute("isvalid", "true")
            } else {
                input.classList.add("woocommerce-invalid");
                //input.setCustomValidity(validation);
                input.setAttribute("isvalid", "false")
            }
        }
      });
  }

	// // scroll to top
	// $("a.top").click(function() {
	// 		$("html, body").animate({
	// 				scrollTop: 0
	// 		}, "slow");
	// 		return false;
	// });
});


// WEBPACK FOOTER //
// ./resources/js/scripts.js